import HeaderComponent from "../component/header";

const ErrorPage: React.FC = () => {
    
    return (
        <div className="flex">
            <HeaderComponent />
            <div className="flex mt-10 body-height">
                <h1>Invalid Email Verification</h1>
            </div>
        </div>
    );
};

export default ErrorPage;